"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserve = void 0;
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var useResizeObserve = function (ref) {
    var _a = react_1.useState(ref.current ? ref.current.clientWidth : window ? window.innerWidth : 0), width = _a[0], setWidth = _a[1];
    function handleWidth() {
        if (ref.current) {
            setWidth(ref.current.clientWidth);
        }
    }
    react_1.useEffect(function () {
        var resizeObserver = new resize_observer_polyfill_1.default(handleWidth);
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        return function () {
            if (ref.current) {
                resizeObserver.unobserve(ref.current);
            }
        };
    }, [ref]);
    return width;
};
exports.useResizeObserve = useResizeObserve;
